// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 책갈피 탐색기 — 왼쪽 탐색기 맨 아래. 탐색기 트리는 남은 높이를 다시 재서 줄어든다(ResizeObserver) */
.bmx {
  flex-shrink: 0;
  border-top: 1px solid var(--color-border, #e5e7eb);
  background: var(--color-bg-secondary, #f8f9fa);
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.bmx-head {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 5px 10px;
  border: none;
  background: none;
  color: var(--color-text-muted, #6b7280);
  font-size: 12px;
  cursor: pointer;
  text-align: left;
  transition: color 150ms ease, background-color 150ms ease;
}
.bmx-head:hover { color: var(--color-text, #1f2937); background: var(--color-hover, rgba(0, 0, 0, 0.04)); }
.bmx-title { flex: 1 1; font-weight: 600; }
.bmx-count {
  min-width: 18px;
  padding: 0 5px;
  border-radius: 8px;
  background: var(--color-border, #e5e7eb);
  font-size: 10.5px;
  text-align: center;
}

/* 펼침 — 높이를 직접 트윈하지 않고 max-height + opacity 로(UI 규칙). 접힌 동안은 누를 수 없다 */
.bmx-body {
  max-height: 0;
  opacity: 0;
  transform: translateY(4px);
  overflow: hidden;
  transition: max-height 200ms ease-out, opacity 180ms ease-out, transform 180ms ease-out;
  pointer-events: none;
}
.bmx-open .bmx-body {
  max-height: calc(34vh / var(--app-zoom, 1));
  opacity: 1;
  transform: translateY(0);
  overflow-y: auto;
  pointer-events: auto;
}
.bmx-empty { padding: 6px 12px 10px; font-size: 11.5px; color: var(--color-text-muted, #9ca3af); }
.bmx-group { padding: 1px 0 2px; }
.bmx-group-title {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 3px 10px 2px;
  border: none;
  background: none;
  font-size: 11px;
  color: var(--color-text-muted, #6b7280);
  cursor: pointer;
  text-align: left;
  transition: color 150ms ease, background-color 150ms ease;
}
.bmx-group-title:hover { color: var(--color-text, #1f2937); background: var(--color-hover, rgba(0, 0, 0, 0.04)); }
.bmx-group-name { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bmx-group-active .bmx-group-name { color: var(--color-text, #1f2937); font-weight: 600; }
.bmx-group-cur {
  flex-shrink: 0;
  padding: 0 5px;
  border-radius: 7px;
  font-size: 9.5px;
  color: #2563eb;
  background: rgba(37, 99, 235, 0.1);
}
.bmx-group-count { flex-shrink: 0; font-size: 10px; font-variant-numeric: tabular-nums; }
.bmx-group-items { animation: bmx-fade 160ms ease-out; }
@keyframes bmx-fade {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}
.bmx-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 3px 12px 3px 18px;
  border: none;
  background: none;
  font-size: 12px;
  color: var(--color-text, #1f2937);
  cursor: pointer;
  text-align: left;
  transition: background-color 150ms ease;
}
.bmx-item:hover { background: var(--color-hover, rgba(59, 130, 246, 0.08)); }
.bmx-name { flex: 1 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bmx-line { font-size: 10.5px; color: var(--color-text-muted, #9ca3af); font-variant-numeric: tabular-nums; }

@media (prefers-reduced-motion: reduce) {
  .bmx-head, .bmx-item, .bmx-body, .bmx-group-title { transition: none; }
  .bmx-group-items { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/BookmarkExplorer.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,cAAc;EACd,kDAAkD;EAClD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;AACA,kBAAkB,iCAAiC,EAAE,mDAAmD,EAAE;AAC1G,aAAa,SAAO,EAAE,gBAAgB,EAAE;AACxC;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;EAChB,uFAAuF;EACvF,oBAAoB;AACtB;AACA;EACE,2CAA2C;EAC3C,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;AACtB;AACA,aAAa,sBAAsB,EAAE,iBAAiB,EAAE,uCAAuC,EAAE;AACjG,aAAa,kBAAkB,EAAE;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,yDAAyD;AAC3D;AACA,yBAAyB,iCAAiC,EAAE,mDAAmD,EAAE;AACjH,kBAAkB,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzG,oCAAoC,iCAAiC,EAAE,gBAAgB,EAAE;AACzF;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA,mBAAmB,cAAc,EAAE,eAAe,EAAE,kCAAkC,EAAE;AACxF,mBAAmB,kCAAkC,EAAE;AACvD;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;AACA,kBAAkB,wDAAwD,EAAE;AAC5E,YAAY,SAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACnG,YAAY,iBAAiB,EAAE,uCAAuC,EAAE,kCAAkC,EAAE;;AAE5G;EACE,oDAAoD,gBAAgB,EAAE;EACtE,mBAAmB,eAAe,EAAE;AACtC","sourcesContent":["/* 책갈피 탐색기 — 왼쪽 탐색기 맨 아래. 탐색기 트리는 남은 높이를 다시 재서 줄어든다(ResizeObserver) */\r\n.bmx {\r\n  flex-shrink: 0;\r\n  border-top: 1px solid var(--color-border, #e5e7eb);\r\n  background: var(--color-bg-secondary, #f8f9fa);\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n.bmx-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  width: 100%;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  background: none;\r\n  color: var(--color-text-muted, #6b7280);\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: color 150ms ease, background-color 150ms ease;\r\n}\r\n.bmx-head:hover { color: var(--color-text, #1f2937); background: var(--color-hover, rgba(0, 0, 0, 0.04)); }\r\n.bmx-title { flex: 1; font-weight: 600; }\r\n.bmx-count {\r\n  min-width: 18px;\r\n  padding: 0 5px;\r\n  border-radius: 8px;\r\n  background: var(--color-border, #e5e7eb);\r\n  font-size: 10.5px;\r\n  text-align: center;\r\n}\r\n\r\n/* 펼침 — 높이를 직접 트윈하지 않고 max-height + opacity 로(UI 규칙). 접힌 동안은 누를 수 없다 */\r\n.bmx-body {\r\n  max-height: 0;\r\n  opacity: 0;\r\n  transform: translateY(4px);\r\n  overflow: hidden;\r\n  transition: max-height 200ms ease-out, opacity 180ms ease-out, transform 180ms ease-out;\r\n  pointer-events: none;\r\n}\r\n.bmx-open .bmx-body {\r\n  max-height: calc(34vh / var(--app-zoom, 1));\r\n  opacity: 1;\r\n  transform: translateY(0);\r\n  overflow-y: auto;\r\n  pointer-events: auto;\r\n}\r\n.bmx-empty { padding: 6px 12px 10px; font-size: 11.5px; color: var(--color-text-muted, #9ca3af); }\r\n.bmx-group { padding: 1px 0 2px; }\r\n.bmx-group-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  width: 100%;\r\n  padding: 3px 10px 2px;\r\n  border: none;\r\n  background: none;\r\n  font-size: 11px;\r\n  color: var(--color-text-muted, #6b7280);\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: color 150ms ease, background-color 150ms ease;\r\n}\r\n.bmx-group-title:hover { color: var(--color-text, #1f2937); background: var(--color-hover, rgba(0, 0, 0, 0.04)); }\r\n.bmx-group-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.bmx-group-active .bmx-group-name { color: var(--color-text, #1f2937); font-weight: 600; }\r\n.bmx-group-cur {\r\n  flex-shrink: 0;\r\n  padding: 0 5px;\r\n  border-radius: 7px;\r\n  font-size: 9.5px;\r\n  color: #2563eb;\r\n  background: rgba(37, 99, 235, 0.1);\r\n}\r\n.bmx-group-count { flex-shrink: 0; font-size: 10px; font-variant-numeric: tabular-nums; }\r\n.bmx-group-items { animation: bmx-fade 160ms ease-out; }\r\n@keyframes bmx-fade {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n.bmx-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 3px 12px 3px 18px;\r\n  border: none;\r\n  background: none;\r\n  font-size: 12px;\r\n  color: var(--color-text, #1f2937);\r\n  cursor: pointer;\r\n  text-align: left;\r\n  transition: background-color 150ms ease;\r\n}\r\n.bmx-item:hover { background: var(--color-hover, rgba(59, 130, 246, 0.08)); }\r\n.bmx-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.bmx-line { font-size: 10.5px; color: var(--color-text-muted, #9ca3af); font-variant-numeric: tabular-nums; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .bmx-head, .bmx-item, .bmx-body, .bmx-group-title { transition: none; }\r\n  .bmx-group-items { animation: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
